import TextCreate from 'core/display/simple/Text'
import { FormatService } from 'services/FormatService'
import { LocalizationService } from 'services/LocalizationService'
import { signal } from 'services/SignalsService'

export default class AutoLimitSelectedText extends TextCreate{
  constructor(data) {
    super(data)
    this.data = data
    signal.on(`RADIO:${this.data.name}`, this.update.bind(this))
    signal.on('MODEL:BET', this.update.bind(this))
  }

  update() {
    const limit = game.models.AutoLimitModel.getType(this.data.name)
    let limitText = LocalizationService.get(this.data.text)
    if (Number.isFinite(limit)){
      super.update( limitText + '   ' + FormatService.currency(limit))
    }
    else {
      super.update(limitText + '   ' + LocalizationService.get('noLimit'))
    }
  }
}
